import { AbstractControl, ValidatorFn, Validators } from "@angular/forms";
import { Tools } from "@comunicare/comunicare-helper";

export default class Validation {
  /**
   * Creates a validator ensuring a password control's value matches the shared password strength
   * policy defined in `@comunicare/comunicare-helper` (`Tools.PWD_REGEX`), so every form checks the
   * same rule and only the helper needs updating if that policy ever changes.
   * @return A validator function to attach to the password control
   */
  static password(): ValidatorFn {
    return Validators.pattern(Tools.PWD_REGEX);
  }

  /**
   * Creates a validator ensuring two controls of a form group have matching values, setting a
   * "matching" error on the checked control when they differ.
   * @param controlName Name of the control holding the reference value
   * @param checkControlName Name of the control that must match the reference value
   * @return A validator function to attach to the form group
   */
  static match(controlName: string, checkControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName) as AbstractControl;
      const checkControl = controls.get(checkControlName) as AbstractControl;
      if (checkControl.errors && !checkControl.errors["matching"]) {
        return null;
      }
      if (control.value !== checkControl.value) {
        controls.get(checkControlName)?.setErrors({ matching: true });
        return { matching: true };
      } else {
        controls.get(checkControlName)?.setErrors(null);
        return null;
      }
    };
  }
}
